export const DATA_STATUS =[
    {
        id: 1,
        status: "En depouillement",
        color: "warning",
        description: "En cours de depouillement",
        dateStatus : new Date("2024-12-25"),
        idOffre:1
    },
    {
        id: 2,
        status: "En phase d'entretient",
        color: "warning",
        icon: "clock",
        description: "Les candidats selectionnées en entretien",
        dateStatus : new Date("2025-01-10"),
        idOffre:1
    },
    {
        id: 3,
        status: "Fin",
        color: "warning",
        icon: "clock",
        description: "Fin du traitement",
        dateStatus : new Date("2025-02-15"),
        idOffre:1
    },
    {
        id: 4,
        status: "En depouillement",
        color: "warning",
        icon: "clock",
        description: "En cours de depouillement",
        dateStatus : new Date("2024-12-25"),
        idOffre:2
    },
   
]